import React from 'react'
import Dialog from '@mui/material/Dialog'
import { FormProvider, useForm } from 'react-hook-form'
import {
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle,
  Grid,
  TextField
} from '@mui/material'
import SubmitButton from '../../commonUIComponents/SubmitButton'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import updateEmailAddressService from '../../../services/updateEmailAddressService'

const UpdateAccountEmailModal = ({ open, onClose }) => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods

  const submitHandler = values => {
    const formValues = {
      password: values.password,
      newEmailAddress: values.newEmailAddress
    }
    return updateEmailAddressService.sendUpdateEmailAddressLink(formValues)
      .then(res => {
        enqueueSnackbar('A verification to confirm this update was sent to your current account email address', { variant: 'success' })
        navigate('/login')
      })
      .catch(err => enqueueSnackbar(err.response?.data?.message, { variant: 'warning' }))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <DialogTitle>Email address</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500]
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent sx={{ mt: '-1rem' }}>
            <DialogContentText>
              We&apos;ll send a verification email to the email address you provide to confirm that it&apos;s really you.
            </DialogContentText>
            <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
              <Grid item xs={12}>
                <TextField
                  label="Password"
                  type="password"
                  {...register('password',
                    {
                      required: {
                        value: true,
                        message: 'Invalid Password'
                      }
                    }
                  )}
                  error={errors.password}
                  helperText={errors.passwword?.message}
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="New email"
                  {...register('newEmailAddress',
                    {
                      required: {
                        value: true,
                        message: 'Invalid Password'
                      }
                    }
                  )}
                  error={errors.newEmailAddress}
                  helperText={errors.newEmailAddress?.message}
                  margin="dense"
                  fullWidth
                />
              </Grid>
            </Grid>
            <DialogActions>
              <SubmitButton buttonLabel="Save" textAlign="right"/>
            </DialogActions>
          </DialogContent>
        </form>
      </FormProvider>
    </Dialog>
  )
}

export default UpdateAccountEmailModal
